import { IRequest } from '@r1-frontend/shared/types/IRequest';

/**
 * Получение данных по текущему тарифу пользователя
 * @link https://master.api-tariffs.sandbox.d2c.r-one.io/docs/#/Tariff/TariffController_current
 */
export const current = (): IRequest => ({
    uri: 'v1/tariff/current',
    method: 'GET',
    withProvider: true,
    withAuth: true,
});
